export default {
  SHOW_MODAL: "@ui/MODAL_SHOW",
  HIDE_MODAL: "@ui/MODAL_HIDE",
  CLOSE_ALL_MODAL: "@ui/CLOSE_ALL_MODAL",
  REPLACE_MODAL: "@ui/MODAL_REPLACE"
};
